<template>
  <div>
    <top-navbar></top-navbar>
    <div class="mb-5 background_color">
      <h6 class="manage-boder pt-2 font1 decoration">
        <router-link class="decoration" to="/">Home</router-link
        ><span class="pfimg3"><i class="fa fa-angle-right"></i></span>
        Distribution
        <span class="pfimg3"><i class="fa fa-angle-right"></i></span
        ><router-link class="decoration" to="/dreceipt/index"
          >Manage Receipt</router-link
        ><span class="pfimg3"><i class="fa fa-angle-right"></i></span
        >{{ receipt.receipt_num || "View Receipt" }}
      </h6>
      <div class="container-fluid">
        <div class="d-flex justify-content-end mb-1 mt-1">
          <button
            v-if="receipt.status === 1"
            @click="confirmReceipt"
            class="btn btn-sm btn-outline-primary bdr-rad mr-2"
          >
            Confirm</button
          ><button
            @click="$router.push('/dreceipt/index')"
            class="btn btn-sm btn-outline-primary bdr-rad "
          >
            Back
          </button>
        </div>
        <div v-if="isLoading" class="card bdr-rad2 shadow p-4 text-center">
          <div class="spinner-border text-primary"></div>
        </div>
        <div v-else>
          <div class="card bdr-rad2 shadow p-2">
            <div class="card-body">
              <table class="table table-sm table-borderless detail-table">
                <tbody>
                  <tr>
                    <td><b>Receipt No.</b></td>
                    <td>{{ receipt.receipt_num }}</td>
                  </tr>
                  <tr>
                    <td><b>Customer</b></td>
                    <td>{{ receipt.customer }}</td>
                  </tr>
                  <tr>
                    <td><b>Receipt Date</b></td>
                    <td>{{ receipt.receipt_date }}</td>
                  </tr>
                  <tr>
                    <td><b>Payment Mode</b></td>
                    <td>{{ receipt.payment_mode }}</td>
                  </tr>
                  <tr>
                    <td><b>Cash Amount</b></td>
                    <td>{{ money(receipt.cash_amount) }}</td>
                  </tr>
                  <tr>
                    <td><b>Bank Name</b></td>
                    <td>{{ receipt.bank_name || "-" }}</td>
                  </tr>
                  <tr>
                    <td><b>Over Payment</b></td>
                    <td>{{ money(receipt.overpayment) }}</td>
                  </tr>
                  <tr>
                    <td><b>Remarks</b></td>
                    <td>{{ receipt.remarks || "-" }}</td>
                  </tr>
                  <tr>
                    <td><b>Status</b></td>
                    <td>{{ receipt.status_name }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="card bdr-rad2 shadow p-2 mt-3">
            <div class="card-body">
              <h6 class="purchitem mb-2"><b>Receipt Invoices</b></h6>
              <div class="table-responsive">
                <table class="table table-sm table-hover receipt-table">
                  <thead class="background_color2">
                    <tr>
                      <th>#</th>
                      <th>Invoice No.</th>
                      <th class="text_right">Due Amount</th>
                      <th class="text_right">Payment</th>
                      <th class="text_right">Balance</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in details" :key="item.invoice_id">
                      <td>{{ index + 1 }}</td>
                      <td>{{ item.invoice_num }}</td>
                      <td class="text_right">{{ money(item.due_amount) }}</td>
                      <td class="text_right">{{ money(item.payment) }}</td>
                      <td class="text_right">{{ money(item.balance) }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <content-footer></content-footer>
  </div>
</template>

<script>
import axios from "axios";
import authService from "@/auth.service";
import TopNavbar from "./../../layout/TopNavbar.vue";
import ContentFooter from "./../../layout/ContentFooter.vue";

export default {
  components: { TopNavbar, ContentFooter },
  data: () => ({
    token: authService.isLoggedIn(),
    receipt: {},
    details: [],
    isLoading: true,
  }),
  mounted() {
    this.load();
  },
  methods: {
    money(value) {
      return Number(value || 0).toFixed(2);
    },
    async load() {
      try {
        const { data } = await axios.get(
          "/dreceipt/view?id=" + this.$route.query.id,
          { headers: { Authorization: "Bearer " + this.token } }
        );
        this.receipt = data.all_data || {};
        this.details = data.details || [];
      } finally {
        this.isLoading = false;
      }
    },
    async confirmReceipt() {
      if (!window.confirm("Confirm this receipt?")) return;
      await axios.post(
        "/dreceipt/confirm?id=" + this.receipt.id,
        {},
        { headers: { Authorization: "Bearer " + this.token } }
      );
      await this.load();
    },
  },
};
</script>

<style scoped>
.background_color {
  background: #eaf6ff;
  min-height: calc(100vh - 60px);
}
.background_color2 {
  background: #235983;
  color: #fff;
}
.bdr-rad {
  border-radius: 12px;
}
.bdr-rad2 {
  border-radius: 15px;
}
.decoration {
  color: #fff !important;
  text-decoration: none;
}
.font1 {
  font-size: 13px !important;
}
.manage-boder {
  background: #087df5;
  color: #fff;
  padding: 10px 15px !important;
  margin: 0 !important;
  line-height: normal;
}
.detail-table,
.receipt-table {
  font-size: small;
}
.detail-table td:first-child {
  width: 220px;
}
.text_right {
  text-align: right;
}
</style>
